import { login as loginApi, logout, getInfo, getPublicKey, changePassword as changePasswordApi } from '@/api/auth'
import { getToken, setToken, removeToken } from '@/utils/auth'
import JSEncrypt from 'jsencrypt'

const state = {
  token: getToken(),
  userInfo: {}
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER_INFO(state, info) {
    state.userInfo = info
  }
}

function encryptPassword(publicKeyPem, password) {
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(publicKeyPem)
  const encrypted = encrypt.encrypt(password)
  if (!encrypted) {
    throw new Error('密码加密失败，请重试')
  }
  return encrypted
}

const actions = {
  async login({ commit }, { username, password, captchaKey, captchaCode }) {
    const keyRes = await getPublicKey()
    const publicKey = keyRes.data && keyRes.data.publicKey
    if (!publicKey) {
      throw new Error('获取加密公钥失败，请刷新重试')
    }
    const encryptedPassword = encryptPassword(publicKey, password)
    const res = await loginApi({ username, password: encryptedPassword, captchaKey, captchaCode })
    const data = res.data
    if (data && data.token) {
      commit('SET_TOKEN', data.token)
      commit('SET_USER_INFO', { userName: data.userName, userId: data.userId })
      setToken(data.token)
    }
    return res
  },

  async getInfo({ commit }) {
    const res = await getInfo()
    if (res.data) {
      commit('SET_USER_INFO', res.data)
    }
    return res
  },

  logout({ commit }) {
    logout().catch(() => {})
    commit('SET_TOKEN', '')
    commit('SET_USER_INFO', {})
    removeToken()
  },

  async changePassword({ state }, { oldPassword, newPassword }) {
    const keyRes = await getPublicKey()
    const publicKey = keyRes.data && keyRes.data.publicKey
    if (!publicKey) {
      throw new Error('获取加密公钥失败，请重试')
    }
    const encryptedOld = encryptPassword(publicKey, oldPassword)
    const encryptedNew = encryptPassword(publicKey, newPassword)
    return changePasswordApi({ oldPassword: encryptedOld, newPassword: encryptedNew })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
